export default "__VITE_ASSET__hhhKbug4__"